/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  return {
    variables: { type: props.type },
    pause: !props.type,
    requestPolicy: 'cache-and-network',
  }
}
